import { Layout, Skeleton } from '../../components/core';
import { PageContent, PageFooter } from '../../components/page';
import { IntroView } from '../../content/view/components/IntroView';
import { View } from '../../content/view/components/View';
import { useHasCompletedAnySkillQuery } from '../../graphQL';
import { getStylesheet } from '../../styles';
import { AboutTheseGuides } from './components/AboutTheseGuides';
import { JumpBackIn } from './components/JumpBackIn';
import { SelfCareHeader } from './components/SelfCareHeader';
import { YourPathway } from './components/YourPathway';

export const SelfCareHomePage = (): JSX.Element => {
  const { data, loading: introLoading } = useHasCompletedAnySkillQuery();

  const hasCompletedIntro = data?.hasCompletedAnySkill ?? false;

  return (
    <PageContent testID="self-care-home">
      <SelfCareHeader />

      <Layout.VStack space={12}>
        <YourPathway />

        <Layout.View {...styles.intro}>
          {introLoading && (
            <Layout.VStack {...styles.stack} paddingY={4}>
              <Skeleton height={351} />
            </Layout.VStack>
          )}

          {!introLoading && !hasCompletedIntro && (
            <Layout.VStack {...styles.stack}>
              <IntroView />
            </Layout.VStack>
          )}

          {!introLoading && hasCompletedIntro && (
            <Layout.VStack {...styles.stack}>
              <JumpBackIn />
            </Layout.VStack>
          )}
        </Layout.View>

        <Layout.VStack {...styles.stack} space={84}>
          <View isCollection={false} />

          <View isCollection={true} />

          {hasCompletedIntro && <AboutTheseGuides />}
        </Layout.VStack>
      </Layout.VStack>

      <PageFooter />
    </PageContent>
  );
};

const styles = getStylesheet({
  intro: {
    backgroundColor: 'secondary.200',
    paddingX: 4,
    paddingY: 8,
  },

  stack: {
    alignSelf: 'center',
    width: '100%',
  },
});
